import AngularComponents from './angularjs/angularImports';

typeof AngularComponents;

window.Vue = require('vue');